import { useGlobal } from 'hooks/useGlobal';

/**
 * A request to open one test's learnings in the Library, held in the query cache.
 *
 * `?open=<id>` in the URL is read once, when the Library mounts (useQueryState keeps its value in
 * component state seeded from the URL), so a link clicked while the Library is already on screen
 * changes the address and nothing else. The Ask answers and the ideas list are on that screen, so
 * their links set this instead: it is reactive, it does not touch the URL, and it leaves the scope
 * keys (`org`, `ws`) in the address where they are. The Library acts on whichever it finds first and
 * clears both.
 */
export const useOpenRequest = () => useGlobal<number | null>('LIBRARY_OPEN_REQUEST', null);
